<template>
  <el-dialog
    :title="title?title:'提示'"
    :visible.sync="dialogVisible"
    :class="{'school-center': $store.getters.curTheme}"
    :append-to-body="true"
    :close-on-click-modal="false"
    :width="width || '80%'"
    :before-close="handleClose">
    <ElementForm
      v-if="dialogVisible"
      ref="form"
      :form.sync="newForm"
      @onAttr="onAttr"
    />
    <ElementForm
      v-if="dialogVisible && newForm2 && newForm2.length>0"
      ref="form2"
      :form.sync="newForm2"
      @onAttr="onAttr"
    />
    <slot></slot>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button :loading="loading" type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'im-form',
  props: {
    title: String,
    visible: {
      type: Boolean,
      default: false
    },
    form: {
      type: Array
    },
    form2: {
      type: Array
    },
    width: String,
    defaultValue: Object,
    type: String,
    isPlat: {
      type: Boolean,
      default: false
    },
    // 是否手动关闭
    isSelfClose: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible (vl) { this.dialogVisible = vl },
    dialogVisible (vl) { this.$emit('update:visible', vl) },
    form: {
      handler (vl) {
        this.newForm = vl
      },
      deep: true,
      immediate: true
    },
    newForm: {
      handler (vl) {
        this.$emit('update:form', vl)
      },
      deep: true,
      immediate: true
    },
    form2: {
      handler (vl) {
        this.newForm2 = vl
      },
      deep: true,
      immediate: true
    },
    newForm2: {
      handler (vl) {
        this.$emit('update:form2', vl)
      },
      deep: true,
      immediate: true
    },
    defaultValue (vl) { this.newDefaultValue = vl },
    newDefaultValue (vl) { this.$emit('update:defaultValue', vl) },
    type (vl) { this.newType = vl },
    newType (vl) { this.$emit('update:type', vl) },
    isPlat (vl) { this.newIsPlat = vl },
    newIsPlat (vl) { this.$emit('update:isPlat', vl) }
  },
  created () {
    this.init()
  },
  data () {
    return {
      dialogVisible: this.visible,
      newForm: this.$_.cloneDeepWith((this.form)),
      newForm2: this.$_.cloneDeepWith((this.form2)),
      newDefaultValue: this.defaultValue,
      newType: this.type,
      newIsPlat: this.isPlat
    }
  },
  methods: {
    init () {
      // 如果有默认值，初始化数据
      if (this.newDefaultValue) {
        this.newForm.map(v => {
          if (this.newDefaultValue[v.attr]) {
            v.value = this.newDefaultValue[v.attr]
          }
        })
      }

      const coverIndex = this.$utils.getIndexByAttr({ attr: 'cover', data: this.newForm })
      if (coverIndex > -1) {
        this.newForm[coverIndex].isPlat = this.newIsPlat
        // 处理添加或编辑素材
        switch (this.type) {
          case 'image':
            this.newForm[coverIndex].name = '图片'
            this.newForm[coverIndex].props.accept = '.png,.jpeg,.jpg'
            break
          case 'audio':
            this.newForm[coverIndex].name = '音频'
            this.newForm[coverIndex].props.accept = '.mp3'
            break
          case 'video':
            this.newForm[coverIndex].name = '视频'
            this.newForm[coverIndex].props.accept = '.mov,.mp4'
            break
        }
      }
    },
    onAttr (item) {
      console.log('777', item)
      switch (item.attr) {
        case 'cover': {
          const coverIndex = this.$utils.getIndexByAttr({ attr: 'cover', data: this.newForm })
          const nameIndex = this.$utils.getIndexByAttr({ attr: 'name', data: this.newForm })
          if (this.newForm[coverIndex].value.name) this.newForm[nameIndex].value = this.newForm[coverIndex].value.name
          break
        }
      }
      this.$emit('onAttr', item)
    },
    handleClose () {
      this.dialogVisible = false
    },
    submit () {
      const newData = this.$_.cloneDeepWith(this.newForm)
      const newData2 = this.$_.cloneDeepWith(this.newForm2)
      const state = this.$refs.form.validateForm()
      // let state2 =  false
      // if (this.$refs.form2) state2 = this.$refs.form2.validateForm()
      console.log('表单校验==>', newData, newData2, state)

      if (state) {
        let arr = []
        arr = arr.concat(newData)
        if (newData2 && newData2.length > 0) arr = arr.concat(newData2)
        this.$emit('success', arr)
        !this.isSelfClose && this.handleClose()
      }
    }
  }
}
</script>

<style scoped>

</style>
